"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.divide = void 0;
const exception_1 = require("../exception");
const value_1 = require("../value");
const utils_1 = require("./utils");
const divNumber = (a, b) => {
    if (b.value.comparedTo(0) === 0) {
        throw new exception_1.RangeError("Division by zero.");
    }
    return (0, value_1.newNumberValue)(a.value.div(b.value));
};
const divVector = (a, b) => (0, utils_1.vectorValueBinaryOperator)(a, b, exports.divide);
const divNumberFromVector = (a, b) => (0, utils_1.vectorValueNumberBinaryOperator)(a, b, exports.divide);
const divide = (a, b) => {
    if (a.type === b.type) {
        switch (a.type) {
            case "Number":
                return divNumber(a, b);
            case "Vector":
                return divVector(a, b);
        }
    }
    else if (b.type === "Number") {
        if (a.type === "Vector") {
            return divNumberFromVector(a, b);
        }
    }
    throw new exception_1.TypeError(`Cannot divide ${a.type.toLowerCase()} with ${b.type.toLowerCase()}.`);
};
exports.divide = divide;
